import React, { useState, useEffect } from 'react';
import { publicApi, getImageUrl } from '../lib/api';

export default function SponsorsStrip() {
  const [sponsors, setSponsors] = useState([]);

  useEffect(() => {
    publicApi.getSponsors().then(res => setSponsors(res.data)).catch(() => {});
  }, []);

  if (sponsors.length === 0) return null;

  return (
    <section className="py-12 sm:py-16 border-t border-white/5">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <span className="text-xs text-white/30 uppercase tracking-[0.2em]">Unsere Sponsoren</span>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-8 sm:gap-12">
          {sponsors.map(s => (
            <a key={s._id} href={s.link || '#'} target={s.link ? '_blank' : '_self'} rel="noopener noreferrer"
              className="flex flex-col items-center gap-2 hover:opacity-100 transition-opacity duration-200 opacity-80 flex-shrink-0">
              {s.logoMime ? (
                <img src={getImageUrl(`/api/public/sponsors/${s._id}/logo`)} alt={s.name}
                  className="h-12 sm:h-14 w-auto object-contain" />
              ) : null}
              <span className="text-xs text-white/40 font-medium">{s.name}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
